/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/followup/followup.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { NgModule } from "@angular/core";
import { FollowupRoutingModule } from "./followup-routing.module";
import * as i0 from "@angular/core";
export class FollowupModule {
    constructor() {
    }
}
FollowupModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    FollowupRoutingModule,
                ],
            },] },
];
/** @nocollapse */
FollowupModule.ctorParameters = () => [];
/** @nocollapse */ FollowupModule.ɵmod = i0.ɵɵdefineNgModule({ type: FollowupModule });
/** @nocollapse */ FollowupModule.ɵinj = i0.ɵɵdefineInjector({ factory: function FollowupModule_Factory(t) { return new (t || FollowupModule)(); }, imports: [[
            FollowupRoutingModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FollowupModule, { imports: [FollowupRoutingModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(FollowupModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FollowupRoutingModule,
                ],
            }]
    }], function () { return []; }, null); })();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9sbG93dXAubW9kdWxlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vLi4vLi4vdmlzaW9uaWNzL25nL3NyYy9hcHAvZm9sbG93dXAvZm9sbG93dXAubW9kdWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsT0FBTyxFQUFDLFFBQVEsRUFBQyxNQUFNLGVBQWUsQ0FBQztBQUN2QyxPQUFPLEVBQUMscUJBQXFCLEVBQUMsTUFBTSwyQkFBMkIsQ0FBQzs7QUFPaEUsTUFBTSxPQUFPLGNBQWM7SUFDekI7SUFBZSxDQUFDOzs7WUFOakIsUUFBUSxTQUFDO2dCQUNSLE9BQU8sRUFBRztvQkFDUixxQkFBcUI7aUJBQ3RCO2FBQ0Y7Ozs7a0RBQ1ksY0FBYzsyR0FBZCxjQUFjLGtCQUpmO1lBQ1IscUJBQXFCO1NBQ3RCO3dGQUVVLGNBQWMsY0FIdkIscUJBQXFCO2tEQUdaLGNBQWM7Y0FMMUIsUUFBUTtlQUFDO2dCQUNSLE9BQU8sRUFBRztvQkFDUixxQkFBcUI7aUJBQ3RCO2FBQ0YiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQge05nTW9kdWxlfSBmcm9tIFwiQGFuZ3VsYXIvY29yZVwiO1xuaW1wb3J0IHtGb2xsb3d1cFJvdXRpbmdNb2R1bGV9IGZyb20gXCIuL2ZvbGxvd3VwLXJvdXRpbmcubW9kdWxlXCI7XG5cbkBOZ01vZHVsZSh7XG4gIGltcG9ydHMgOiBbXG4gICAgRm9sbG93dXBSb3V0aW5nTW9kdWxlLFxuICBdLFxufSlcbmV4cG9ydCBjbGFzcyBGb2xsb3d1cE1vZHVsZSB7XG4gIGNvbnN0cnVjdG9yKCkge31cbn1cbiJdfQ==